import { __awaiter } from "tslib";
import React, { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom';
import { buildModuleProps } from 'pathfinder/rules-engine/moduleProps';
import log from 'pathfinder/utils/log';
import { checkIfElementExists } from 'pathfinder/modules/shared/helpers/checkIfElementExists';
const getNewImagesContainer = () => {
    return document.querySelector('.photo-module');
};
const getParentContainer = () => {
    return document.querySelector('.page__right-rail');
};
export const getRecentImagesModuleMethods = (moduleConfig) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const moduleProps = buildModuleProps(moduleConfig);
        const reactRoot = document.createElement('div');
        const stickyModulesWrapper = document.querySelector('.sticky-modules-wrapper');
        if (!stickyModulesWrapper) {
            return;
        }
        const element = yield checkIfElementExists(getNewImagesContainer, getParentContainer());
        // don't show the module if it has NewImages module
        if (element) {
            return null;
        }
        stickyModulesWrapper === null || stickyModulesWrapper === void 0 ? void 0 : stickyModulesWrapper.insertAdjacentElement('beforebegin', reactRoot);
        const RecentImagesModule = lazy(() => import('./RecentImagesModule'));
        const lazyComponent = () => {
            return (React.createElement("div", null,
                React.createElement(Suspense, { fallback: React.createElement("div", { style: { height: '280px' } }) },
                    React.createElement(RecentImagesModule, Object.assign({}, moduleProps)))));
        };
        const render = () => {
            ReactDOM.render(React.createElement(lazyComponent, moduleProps), reactRoot);
            return reactRoot;
        };
        return {
            render,
        };
    }
    catch (error) {
        log.debug('RecentImagesModule error', error);
    }
    return null;
});
